import { render, staticRenderFns } from "./DCB.vue?vue&type=template&id=5236f06a&scoped=true"
import script from "./DCB.vue?vue&type=script&lang=js"
export * from "./DCB.vue?vue&type=script&lang=js"
import style0 from "./DCB.vue?vue&type=style&index=0&id=5236f06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236f06a",
  null
  
)

export default component.exports